<div class="d-flex justify-content-center w-100" #anchor>
  <div class="py-3">
    @if (isLoading) {
      <mat-spinner [diameter]="diameter"></mat-spinner>
    }
  </div>
</div>
